import styled from "styled-components";

export const Nav = styled.div`
  top: 0;
  left: 0;
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  overflow: hidden;
  height: 60px;
  padding: 0 10px;
  z-index: 100;
  display: flex;
  align-items: center;
  transition: height 250ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
`;

export const LogoElem = styled.img`
  cursor: pointer;
`;

export const LinksContainer = styled.div`
  height: 100%;
  padding: 0 50px;
  display: flex;
  align-items: center;

  @media (max-width: 1050px) {
    display: none;
    flex-direction: column;
    padding: 0;
    width: 100%;
    justify-content: space-evenly;
  }
`;

export const HamburgerLinksContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
  width: 100%;
  justify-content: space-evenly;

  @media (min-width: 1050px) {
    display: none;
    flex-direction: column;
    padding: 0;
    width: 100%;
    justify-content: space-evenly;
  }
`;

export const StyledLink = styled.div`
  position: relative;
  padding: 0 20px;
  border-radius: 10px;
`;

export const HamburgerContainer = styled.div`
  z-index: 100;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
  position: absolute;
  right: 8px;

  @media (min-width: 1050px) {
    display: none;
  }
`;

export const HamburgerMenu = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: white;
  z-index: 99;
  display: flex;
`;
